const en = {
	certification: {
		verification: 'Identity Verification',
		updateHistory: 'Update History',
		certificateRequired: 'Certificate Required',
		changeIdentites: 'Change Identites',
		changePerson: 'Change legal person、shareholders、beneficial owners',
		completeIdentityVerification: 'Complete Identity Verification',
		verificationTips: 'According to the requirements of relevant regulatory and to ensure the security of your account,pingpong needs to collect the identity information and verify it,',
		verificationTips2nd: 'Pingpong promises to keep the information you provide strictly confidential.',
		imgUploadTips: 'Uploading requirements: please ensure that, ',
		imgUploadTips2nd: 'the information in the photo is clear and visible to improve approval efficiency',
		imgUploadTips3rd: 'the maximum size is no more than 10M, the format is limited to JPG, JPEG, PNG, BMP.',
		imgExample: 'Check image examples',
		auditReport: 'Audit Report',
		writeCompany: 'Enter Business Information',
		writeLegal: 'Enter Applicant’s Identity',
		writeDirector: 'Enter Shareholder’s Identity',
		writeDirector2: 'Enter Director’s Identity',
		writeBeneficiary: 'Enter Beneficiary’s Identity',
		uploadDesc: 'Please ensure that the information in the photo is clear and visible to improve approval efficiency.'
	},
	photoTips: {
		correct: 'Correct specifications: ',
		error: 'Error examples: ',
		specification1: 'The four corners must be fully displayed',
		specification2: 'Uniform brightness without reflection',
		specification3: 'Clear and highly recognizable content',
		example1: 'Incomplete photo',
		example2: 'The photo is blurry and blurry',
		example3: 'The photo has severe reflection'
	},
	review: {
		messageTip: 'Please wait patiently while your identity information is under review',
		messageReSubmit: 'The identity information you submitted failed to pass due to missing data or wrong information. Please submit again.',
		approved: 'Your identity information has been approved',
		uneligible: 'Unfortunately, you are currently not eligible.'
	},
	add: {
		applicantsIdentity: 'Add Applicant’s Identity',
		informationofApplicant: 'Please fill in the information of Applicant’s Identity',
		addApplicantIdentity: 'Add Applicant’s Identity',
		shareholderIdentity: 'Add Shareholder’s Identity',
		shareholderIdentity2: 'Add Director’s Identity',
		informationofshareholder: 'Please fill in the information of all shareholder’s identity',
		informationofshareholder2: 'Please fill in the information of all director’s identity',
		addashareholder: 'Add a shareholder',
		addashareholder2: 'Add a director',
		BeneficiaryIdentity: 'Add Beneficiary’s Identity',
		informationofBeneficiary: 'Please fill in the information of shareholders holding shares >=25%',
		informationofBeneficiary2: 'Please fill in the information of directors holding shares >=25%',
		addabeneficiary: 'Add a beneficiary',
		goBack: 'Go back',
		saveAndNext: 'Save and next',
		submitwebsite: 'Submit and add a website',
		submitVerification: 'Submit Identity Verification',
		save: 'Save',
		deleted: 'Delete Success',
		deleteFailed: 'delete Failed',
		tryAgain: 'Please Try Again',
		pic: 'Add a pic',
		uploadFile: 'upload files',
		reupload: 'reupload',
		uploadSuccess: 'upload success',
		notice: 'notice',
		uploadFileNotice: 'the maximum size is no more than ',
		imgLimited: 'Picture should be in JPG, JPEG, PNG, BMP format',
		pictureFormatError: 'Picture format error',
		picUploadSuccess: 'Picture is uploaded successfully',
		uploadMethods: 'Please select an upload method',
		PleaseUploadInformation: 'Please upload information',
		uploadFailed: 'Image upload failed, please upload again',
		uploadLimited: 'Picture should be in JPG, JPEG, PNG, BMP format',
		uploadagain: 'Please delete the original picture and upload again',
		uploadPic1st: 'Only ',
		uploadPic2nd: ' pictures can be uploaded',
		reupload2: 'Image upload failed',
		choose: 'Choose'
	},
	company: {
		businessInformation: 'Business Information',
		businessLocation: 'Business Location',
		nationality: 'Business Location',
		select: 'Please choose one of the following items.',
		china: 'Mainland, China',
		hongkong: 'Hongkong, China',
		europe: 'Europe',
		america: 'America',
		africa: 'Africa',
		oceania: 'Oceania',
		asia: 'Asia',
		usa: 'United States',
		companyNameChinese: 'Company Legal Name in Chinese',
		companyNameEnglish: 'Company Legal Name in English',
		businessCityChinese: 'Business City in Chinese',
		businessAddressChinese: 'Business Address in Chinese',
		businessCityEnglish: 'Business City in English',
		businessAddressEnglish: 'Business Address in English',
		postCode: 'Zip/Postal Code',
		businessType: 'Business Type',
		soleProprietorship: 'Sole proprietorship',
		companyLimited: 'Company of limited liability',
		jointVentureCompany: 'Joint venture company',
		listedCompany: 'Listed company',
		corporationOrganization: 'Company, corporation, organization',
		others: 'Others',
		businessIdentityNumber: 'Business Identity Number',
		businessEstablishedDate: 'Business Established Date',
		businessExpirationDate: 'Business Expiration Date',
		governmentIssuedBusinessCertification: 'Government Issued Business Certification',
		HKBusinessRegistrationOrdinance: 'Business Registration Ordinance',
		businessRegistrationOrdinanceExpirationDate: 'Certificate of Incorporation Established Date',
		hkBusinessRegistrationOrdinanceEffectDate: 'Business Registration Ordinance Effect Date',
	    hkBusinessRegistrationOrdinanceExpirationDate: 'Business Registration Ordinance Expiration Date',

		selectTheDate: 'Please select the date',
		longTermEffective: 'long term effective',
		certificateofIncorporation: 'Certificate of Incorporation',
		hkCertificateofIncorporation: 'Certificate of Incorporation',
		certificateofIncorporationNumber: 'Certificate of Incorporation Number',
		hkCertificateofIncorporationNumber: 'Certificate of Incorporation Number',

		certificateofIncorporationEstablishedDate: 'Certificate of Incorporation Established Date',
		certificateofIncorporationExpireDate: 'Certificate of Incorporation Expiration Date',
		bankAccountInformation: 'Bank Account Information',
		bankAccountInformationTip: 'Please upload the Bank Account Information',
		picture: 'Picture',
		EXCEL: 'EXCEL',
		pdf: 'PDF',
		officePhotos: 'Office photos',
		tokenofficePhotos: 'Please upload 2-5 photos of office environment and front desk. Please make sure the company name or logo is displayed.',
		submitSelect: 'Please select at least one of the following two items to submit',
		billOrcontract: 'Company office lease contract or Company utility bill',

		companyCharter: 'Articles of Association（If you need to apply for a virtual account, please fill in）',
		companyCharterDesc: 'If you need to add this material after approval, please go to Withdrawal Account—Apply for a virtual account',
		'united-states': 'United States'

	},
	example: {
		checkImageExamples: 'Check image examples',
		uploadTip: 'Uploading requirements: please ensure that the image picture and text are clearly visible, the maximum size is no more than 10M, the format is limited to JPG, JPEG, PNG, BMP and PDF.',
		IDCardExample: 'ID card example',
		businessLicense: 'Business License',
		frontofIDCard: 'Identity Card Portrait Side',
		backofIDCard: 'Identity Card Emblem Side',
		businessIdentity: 'Business Identity',
		hongkongId: 'HongKong Identity Card',
		additionalInformation: 'Additional information',
		provideInfo: 'You can provide additional high-quality materials related to your company so that we can have a better understanding of your company. Information such as proof of director\'s address, US Internal Revenue Service EIN certificate, or personal SSN.',
		uploadMethod: 'Upload method',
		passport: 'Home page of passport',
		travelPermit: 'The photo of Mainland Travel Permit',
		otherPhoto: 'Other photo'
	},
	rules: {
		bankAccountInfo: 'Please upload the Bank Account Information',
		proofFlow: 'Please upload proof of flow',
		registeredCompany: 'Please select the country or region where the company is registered',
		companyChineseName: 'Please enter the Company Legal Name in Chinese',
		companyEnglishName: 'Please enter the Company Legal Name in English',
		chooseCity: 'Please choose the city',
		companyChineseAddress: 'Please enter the company address in chinese',
		companyEnglishAddress: 'Please enter the company address in english',
		companyEnglishCity: 'Please enter the company city in english',
		companyEnglishAddressValid: 'Please input valid information',
		postCode: 'Please enter the Zip/Postal Code',
		postCodeValid: 'Only English and numbers are allowed',
		businessIdentityNumber: 'Please enter business identity number',
		certificateEstablishedDate: 'Please select  certificate of incorporation established date',
		bussinessEstablishedDate: 'Please enter select business established date',
		companyExpiredDate: 'Please enter select company registration certificate date',
		governmentBussinessCertification: 'Please upload the government issued business certification',
		HKgovernmentBussinessCertification: 'Please upload the business registration ordinance',
		governmentBussinessCertification2: 'Please upload the certificate of Incorporation',
		applicationForm: 'Please upload the Application form',
		websiteCertificate: 'Please upload the website domain name registration certificate',
		billOrlease: 'Please upload the company office lease contract or company utility bill',
		addedUser: 'Use added character information',
		IDType: 'ID Type',
		IDCardNumber: 'ID Card Number',
		IDNumber: 'ID Number',
		IDIssueDate: 'ID Issue Date',
		IDExpirationDate: 'ID Expiration Date',
		legal: 'Legal person',
		director: 'Shareholder',
		director2: 'Director Full Legal Name CN',
		beneficial: 'Beneficial owner',
		legalIDCardUpdate: "Update Legal person's ID",
		directorIDCardUpdate: 'Update Shareholder’s ID',
		directorIDCardUpdate2: 'Update Director’s ID',
		beneficialIDCardUpdate: "Update Beneficial owner's ID",
		legalInfoUpdate: 'Update of Legal person',
		directorInfoUpdate: 'Update of Shareholder',
		directorInfoUpdate2: 'Update of Director',
		beneficialInfoUpdate: 'Update of Beneficial owner',
		companyUpdate: 'Update Business Registration Information',
		legalChange: 'Change Legal person',
		directorChange: 'Change Shareholder',
		beneficialChange: 'Change Beneficial owner',
		fullName: ' Full Legal Name CN',
		fullNameEN: ' Full Legal Name EN',
		firstNameEN: ' Full Legal Name EN(First Name)',
		lastNameEN: ' Full Legal Name EN(Last Name)',

		fullShareholderName: ' Full Shareholder Name CN',
		fullShareholderName2: ' Full Name CN',

		fullShareholderNameEN: ' Full Shareholder Name EN',
		firstShareholderNameEN: ' Full Shareholder Name EN(First Name)',
		lastShareholderNameEN: ' Full Shareholder Name EN(Last Name)',

		fullShareholderNameEN2: ' Full Name EN',
		firstShareholderNameEN2: ' Full Name EN(First Name)',
		lastShareholderNameEN2: ' Full Name EN(Last Name)',

		fullBeneficiaryName: ' Full Beneficiary Name CN',
		fullBeneficiaryNameEN: ' Full Beneficiary Name EN',
		firstBeneficiaryNameEN: ' Full Beneficiary Name EN(First Name)',
		lastBeneficiaryNameEN: '  Full Beneficiary Name EN(Last Name)',

		halfName: "'s Name",
		sameInId: 'Please be consistent with the pinyin of  name in ID card',
		phoneNumber: 'Phone Number',
		emailAddress: 'Email Address',
		DOB: 'DOB',
		nationality: 'Residence',
		addressChinese: 'Residential Address in Chinese',
		ConsistentWithid: 'Please be consistent with the address in ID card',
		addressEnglish: 'Residential Address in English',
		save: 'Save',
		submit: 'Submit',
		cancel: 'Cancel',

		InputIDExpirationDate: 'Please select the ID Expiration Date',
		saveSuccess: 'Saved successfully',
		saveFailed: 'Save failed',
		reSave: 'Please save again',
		selectIDType: 'Please select the ID type',
		uploadIDpic: 'Please upload ID card',
		uploadIDbackPic: 'Please upload identity Card Emblem Side',
		inputIDNumber: 'Please enter the ID card number',
		inputIDExpireDate: 'Please select the ID issue Date',
		pleaseEnter: 'Please enter',
		realNameCn: 'Please enter full legal name CN',
		realNameEn: 'Please enter full legal name EN',
		realNameEnRule: 'Please enter English characters only, spaces are not allowed.',
		enterPhoneNumber: 'Please enter the phone number',
		enterEmail: 'Please enter the email address',
		selectDOB: 'Please select the DOB',
		errorDOB: 'The age can not be less than 18 years old',
		selectNation: 'Please select the nationality',
		enterAddressChinese: 'Please enter the residential address in Chinese',
		enterAddressEnglish: 'Please enter the residential address in English',
		selectBussinessType: 'Please select the bussiness type',
		chinaId: 'National Citizen Identity Card',
		hongkongId: 'Hong Kong Identity Card',
		passport: 'Passport',
		permit: 'Mainland Travel Permit(China accounts only)',
		others: 'Others',
		companyCharter: 'Company Charter',
		otherstuff: 'Upload Others',
		companyCharterWarn: 'Please upload company charter',
		companyType: 'Please select the type',
		selectState: 'Select the state',
		inputCity: 'Please input the city',
		selectContinent: 'Please select the continent',
		error1: 'The CertEffectiveDate must before CertExpireDate',
		// 失效日期不能小于生效日期 certEffectiveDate
		error2: 'The CertExpireDate must after CertEffectiveDate',
		error3: 'No action has been taken and cannot be submitted'
	},
	approveInfo: {
		menuList: ['Business Information', 'Legal person Information', 'Shareholders Information', 'Director Information', 'Beneficial owner Information', 'Change record'],
		edit: 'Edit {name}',
		add: 'Add {name}',
		save: 'Save and submit for review',
		saveWarning: 'No operation has been performed and cannot be submitted',
		saveError: 'At least one {name} exists',
		cancel: 'Cancel',
		legal: {
			desc: 'The current legal person'
		},
		director: {
			desc: 'The current shareholders',
			desc2: 'The current directors'
		},
		beneficial: {
			desc: 'The current Beneficial owner'
		}
	},
	update: {
		time: 'Date submitted',
		type: 'Update type',
		status: 'Status',
		operator: 'Operator',
		improved: 'Content to be improved',
		modify: 'Modify',
		go: 'Go to the',
		forDetail: 'to check the certificate review',
		edit: 'Edit'
	},
	status: {
		pending: 'Pending',
		modify: 'Modify',
		passed: 'Passed'
	},
	success: {
		title: 'Success, please continue to add the website.',
		tips: ['The review will be completed within 5 to 7 working days after the sales has finished  pre-review.', 'You may contact your sales to get the progress.'],
		btn: 'Start add website'
	},
	changePerson: {
		toHistory: 'After submitting, you can check review status in <a href="/aq/certification?type=updateHistory" style="color:#1fa0e8;display:inline">【Update History】</a>',
		changeTo: 'Change Identities',
		addLegalTip: 'After submission and approval, the new legal person will automatically replace the current one',
		addLegal: 'Add a leagl person',
		existDirector: 'Current shareholders（Delete only）',
		addDirectorTip: 'Add',
		addDirector: 'Add a shareholder',
		existBeneficial: 'Current beneficial owners（Delete only）',
		addBeneficialTip: 'Please fill in the information of shareholders holding shares >=25%',
		addBeneficial: 'Add a beneficial owner'
	},
	uploadError: 'Please upload {name} files'

}

export default en
